export const messages = {
    'en-US': {
        cancelAction: 'Cancel',
        createAction: 'Create',
        createError: 'An error occurred while creating the price schedule. Please try again.',
        dateRangeLabel: 'Date range',
        itemLabel: 'Item',
        selectItem: 'Select item',
        priceLabel: 'Price',
        currencyLabel: 'Currency',
        reviewLabel: 'Review',
        nextAction: 'Next',
        backAction: 'Back',
        startBeforeEnd: 'Start must be before end',
        scheduleOverlap: 'Schedule overlaps existing',
        today: 'Today',
        loginSuccess: 'Login successful!',
        loginError: 'Login failed. Please try again.',
        loginFailedTitle: 'Login Failed',
        registrationSuccess: 'Registration successful!',
        registrationError: 'Registration failed. Please try again.',
        registrationFailedTitle: 'Registration Failed',
        logoutSuccess: 'Logged out successfully',
        logoutError: 'Logout failed. Please try again.',
        logoutProgress: 'Logging out...',
        registrationSubmitError: 'Failed to submit registration details',
        accountCreatedSuccess: 'Account created successfully!',
        accountCreateFailed: 'Failed to create account. Please fix errors and try again.',
        loginCheckError: 'Login failed. Check your email/password and try again.',
        mfaInitiatedSuccess: 'MFA initiated successfully!',
        mfaPhoneError: 'Failed to register phone number. Please try again.',
        mfaVerifiedSuccess: 'MFA verified successfully!',
        mfaCodeError: 'Invalid or expired code. Please try again.',
        registrationComplete: 'Registration Complete!',
        registrationCompleteDetail: 'You have successfully created your account and set up MFA.',
        goToHome: 'Go to Home',
        goToLogin: 'Go to Login',
        registerAccountHeading: 'Register an Account',
        registerAccountEmailRequired: 'Please enter your email',
        registerAccountInvalidEmail: 'Invalid email format',
        registerAccountPasswordRequired: 'Please enter a password',
        registerAccountPasswordMin: 'Minimum 8 characters',
        registerAccountPasswordComplex: 'Password must contain uppercase, lowercase, and a number',
        registerAccountFirstNameRequired: 'Please enter your first name',
        registerAccountLastNameRequired: 'Please enter your last name',
        registerButton: 'Register',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        preferredNameLabel: 'Preferred Name',
        fullNameLabel: 'Full Name',
        tenantIdLabel: 'Tenant ID',
        roleIdLabel: 'Role ID',
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Password',
        fullNamePlaceholder: 'John Doe',
        tenantIdPlaceholder: 'Tenant ID',
        roleIdPlaceholder: 'Role ID',
        loginHeading: 'Log In',
        loginEmailRequired: 'Email is required',
        loginInvalidEmail: 'Invalid email address',
        loginPasswordRequired: 'Password is required',
        loginButton: 'Log In',
        loginWelcome: 'Welcome to {appName}',
        rememberMeLabel: 'Remember Me',
        dontHaveAccount: "Don't have an account?",
        forgotPassword: 'Forgot Password?',
        mfaPhoneHeading: 'Set Up SMS MFA (Mutli-Factor Authentication)',
        mfaPhoneRequired: 'Please enter a phone number (E.164 format)',
        phoneNumberLabel: 'Phone Number',
        phoneNumberPlaceholder: '+27828940516',
        mfaSecretLabel: 'Secret (Optional)',
        mfaSecretPlaceholder: '(Leave blank if not needed)',
        sendCodeButton: 'Send Code',
        mfaCodeHeading: 'Enter Verification Code',
        mfaCodeLabel: 'Code',
        mfaPlaceholderCode: '123456',
        mfaCodeRequired: 'Please enter the code',
        verifyButton: 'Verify',
        signUpButton: 'Sign Up',
        registerHeading: 'Create a {appName} Account',
        alreadyHaveAccount: 'Already have an account?',
        loginLinkText: 'Log In',
        fullNameRequired: 'Please enter your full name!',
        emailAlreadyExists: 'That email is already registered. Please use a different one.',
        invalidPhoneNumber: 'Phone number is invalid or not a mobile number.',
        invalidPhoneNumberField: 'Invalid phone number',
        registerPhoneNumberError: 'Failed to register phone number. Please try again later.',
        registrationStepAccount: 'Account',
        registrationStepLogin: 'Login',
        registrationStepPhone: 'Phone',
        registrationStepCode: 'Code',
        registrationStepDone: 'Done',
        editPriceScheduleTitle: 'Edit Price Schedule',
        deleteAction: 'Delete',
        saveAction: 'Save',
        deleteConfirmTitle: 'Delete Schedule?',
        deleteScheduleConfirmMessage: 'This action cannot be undone. The schedule will be permanently removed.',
        bookingSuccessHeading: 'Booking Successful',
        bookingSuccessText: 'Your tee time has been confirmed. A confirmation email will arrive shortly.',
        bookingBackHome: 'Back to Home',
        paymentProcessingText: 'Your payment is being processed. Please wait...',
        paymentSuccessHeading: 'Payment Successful',
        paymentSuccessText: 'Your payment was successful. Thank you for your payment.',
        paymentFailedHeading: 'Payment Failed',
        paymentFailedText: 'Your payment was unsuccessful. Please try again or contact support for further assistance.',
        invalidTransactionHeading: 'Invalid Transaction',
        invalidTransactionText: 'Oops! It seems like the url is invalid. Please double-check and ensure that you have entered the correct url.',
        doneAction: 'Done',
        retryAction: 'Retry',
        registrationPaymentConfirmationHeading: 'Payment Confirmation',
        registrationPaymentSuccessText: 'Your club admin has been notified of your successful payment.',
        registrationPaymentNextStepsHeading: 'Next Steps:',
        registrationPaymentNextStepsReview: 'Your application will be reviewed by the club admin.',
        registrationPaymentNextStepsEmail: 'Upon approval, you will receive an email with further instructions to complete your registration.',
        registrationPaymentNextStepsInbox: 'Please be on the lookout for this email in your inbox.',
        passwordResetRequestSuccess: 'Password reset link sent to your email.',
        passwordResetRequestError: 'Unable to send reset link. Please try again later.',
        passwordUpdateSuccess: 'Password updated successfully!',
        passwordUpdateError: 'Failed to update password. Please try again.',
        emailVerificationSuccess: 'Email verified successfully!',
        emailVerificationError: 'Email verification failed. Please try again.',
        settingsHeading: 'Settings',
        settingsLanguageLabel: 'Language',
        settingsThemeLabel: 'Theme',
        termsAcceptLabel: 'I agree to the Terms of Service',
        termsRequired: 'You must accept the Terms of Service to continue',
    },
};
//# sourceMappingURL=en-US.js.map